import './revolve-magazine.scss';



// WEBPACK FOOTER //
// ./styleguide/src/assets/styleguide-critical/revolve-magazine.js